import { render } from "./PdfViewerSidekick.vue?vue&type=template&id=a50c9082&scoped=true"
import script from "./PdfViewerSidekick.vue?vue&type=script&lang=js"
export * from "./PdfViewerSidekick.vue?vue&type=script&lang=js"

import "./PdfViewerSidekick.vue?vue&type=style&index=0&id=a50c9082&scoped=true&lang=css"

import exportComponent from "../../../../../irap-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a50c9082"]])

export default __exports__